import { useEffect, useState } from "react";
import { UserAuth } from "../context/AuthContext";

/**
 * Indica si el usuario actual tiene el rol ADMIN (custom claim `admin: true`).
 * El claim lo pone el servidor y viaja firmado en el token: no es falsificable.
 * Devuelve { isAdmin, loading }.
 */
// Caché por uid (evita el parpadeo de menú al remontar en cada navegación).
const adminCache = {};

export function useIsAdmin() {
  const { user } = UserAuth();
  const cached = user && adminCache[user.uid];
  const [state, setState] = useState(
    cached ? { isAdmin: cached, loading: false } : { isAdmin: false, loading: true }
  );

  useEffect(() => {
    let active = true;
    (async () => {
      if (!user) {
        if (active && user === null) setState({ isAdmin: false, loading: false });
        return;
      }
      try {
        // force refresh: asegura leer un claim recién otorgado.
        const res = await user.getIdTokenResult(true);
        const isAdmin = res.claims.admin === true;
        adminCache[user.uid] = isAdmin;
        if (active) setState({ isAdmin, loading: false });
      } catch {
        if (active) setState({ isAdmin: false, loading: false });
      }
    })();
    return () => {
      active = false;
    };
  }, [user]);

  return state;
}
